import React from 'react';
import { Box, Heading, Modal, Text } from '@zillow/constellation-10';
export interface ConsolidatedPropertyListModalProps {
  propertyList: Array<string>;
  onClose: () => void;
  open: boolean;
}

const ConsolidatedPropertyListModal = ({ propertyList, onClose, open }: ConsolidatedPropertyListModalProps) => (
  <Modal
    header={
      <Heading level={6} css={{ textAlign: 'center' }}>
        Properties
      </Heading>
    }
    body={
      <Box css={{ marginInline: 'md', marginBottom: 'md' }}>
        {propertyList.map((name: string, i: number) => (
          <Box css={{ marginBlock: 'xs' }} key={i}>
            <Text>{name}</Text>
          </Box>
        ))}
      </Box>
    }
    onOpenChange={(isOpen) => {
      if (!isOpen) onClose();
    }}
    open={open}
    size={{ base: 'fullScreen', lg: 'md' }}
  />
);

export default ConsolidatedPropertyListModal;
